export enum OrderStatus {
  CREATED = 'CREATED',
  DENIED = 'DENIED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}
